<div>
  <div class="header" [innerHTML]="'MyProfile_GDPR_Message_Header' | translate"></div>
  <div [innerHTML]="'MyProfile_GDPR_Message' | translate"></div>
</div>
